import React from "react";
import { MarketingPage } from "@/pages/ForFamilies";

export default function ForCaregivers() {
  return (
    <MarketingPage
      testID="for-caregivers"
      seo={{ title: "Caregiver jobs, matched faster", path: "/for-caregivers", description: "Apply in minutes. Background check runs in parallel — no waiting period. Choose W-2 or 1099 and get matched with home care agencies hiring near you." }}
      eyebrow="FOR CAREGIVERS"
      title="Get hired faster. Work the way you want."
      blurb="Apply in minutes. Background check and screening run in parallel — there's no waiting period. Choose W-2, 1099, or either, and get matched with agencies hiring in your area."
      primaryCta={{ label: "Apply now", icon: "user-plus", route: "/caregiver-apply" }}
      features={[
        { icon: "zap", title: "No waiting period", desc: "Your background check runs in parallel with screening, so you can start onboarding right away." },
        { icon: "briefcase", title: "W-2 or 1099", desc: "Tell us how you want to work — agency payroll or independent contractor. We share it with hiring agencies." },
        { icon: "award", title: "Certified or not", desc: "Uncertified? You're considered for companion care and enter a certification track after hire." },
        { icon: "lock", title: "Secure document vault", desc: "Upload ID, certifications and SSN to an encrypted, HR-restricted vault — masked by default." },
        { icon: "gift", title: "Refer & earn points", desc: "Points keep accumulating for as long as each friend works with us — redeemable for gadgets." },
        { icon: "book-open", title: "Training built in", desc: "Assigned modules and clear onboarding steps once you accept your offer." },
      ]}
    />
  );
}
